export default "__VITE_ASSET__DdqaJY7G__"